import Fragment from 'ember-data-model-fragments/fragment';
import type { Type } from '@warp-drive/core/types/symbols';
import { attr } from '@warp-drive/legacy/model';

// Proto: goals.BadgeProfile.
export default class BadgeProfile extends Fragment {
  declare [Type]: 'goals/badge-profile';

  // Unique IRI for the Issuer/Profile file.
  @attr('string')
  declare issuerId: string | undefined;

  // Valid JSON-LD representation of the Issuer or Profile type.
  // In most cases, this will simply be the string "Issuer" or the more general
  // "Profile".
  @attr('string', { defaultValue: '' })
  declare type: string;

  // The name of the entity or organization.
  @attr('string', { defaultValue: '' })
  declare name: string;

  // The homepage or social media profile of the entity, whether individual or
  // institutional.
  @attr('string', { defaultValue: '' })
  declare url: string;

  // Contact address for the individual or organization.
  @attr('string', { defaultValue: '' })
  declare email: string;
}
